import { BaseModel } from "../../Bases/BaseModel";

export class OperacaoFiltroAcesso extends BaseModel {
  constructor(
    public operacao_id = 0,
    public descricao = '',
    public observacao = ''
  ) {
    super();
  }
}